jQuery(document).ready(function ($) {
    var page = 2; // Start from page 2 as the first page is already loaded
    var loading = false;
    var $loadMoreBtn = $('#load-more-posts');

    $loadMoreBtn.on('click', function () {
        if (!loading) {
            loading = true;
            $loadMoreBtn.text('Načítám...');

            $.ajax({
                url: MyAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'load_more_posts',
                    page: page
                },
                success: function (response) {
                    if (response.html) {
                        $('.row.gx-xxl-5.mt-5').append(response.html);
                        page++;
                    }

                    if (!response.has_more_posts) {
                        $loadMoreBtn.hide();
                    }

                    loading = false;
                    $loadMoreBtn.html('<div class="custom-switch"></div>Načíst další');
                },
                error: function () {
                    loading = false;
                    $loadMoreBtn.html('<div class="custom-switch"></div>Načíst další');
                }
            });
        }
    });
});